import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useData } from '@hooks/useData';
import { useGetAllDrivers } from '@services/useGetAllDrivers';

export const DriversMapSetup = () => {
    const { allSettings, login } = useData();
    const { request: fetchDrivers } = useGetAllDrivers();

    // Convert the interval from settings, minutes to milliseconds
    const intervalMinutes = Number(allSettings?.data?.locationUpdateInterval) || 0;
    const intervalMs = intervalMinutes * 60 * 1000;

    useEffect(() => {
        if (!login || intervalMinutes == 0) return;

        const intervalId = setInterval(() => {
            fetchDrivers();
        }, intervalMs);

        return () => clearInterval(intervalId);
    }, [login, fetchDrivers, intervalMs]);

    return (
        <>
            <Outlet />
        </>
    );
};
